import { Navigate, useParams, useSearchParams } from 'react-router-dom';

export function ShortLinkRedirect() {
  const { surveyId, stationId } = useParams();
  const [params] = useSearchParams();
  // Forward `v` cache-buster (written by the manager's QR/share URL) so the
  // long route's React Query key matches and a fresh fetch is forced after a
  // BsEvent config save.
  const v = params.get('v');
  const vQuery = v ? `&v=${encodeURIComponent(v)}` : '';
  // PRD §11 — Manager preview mode is opt-in via the in-config dialog.
  // Forward the flag so PublicSurveyPage tells the wizard to dryRun.
  const preview = params.get('preview') === '1' ? '&preview=1' : '';
  return (
    <Navigate
      to={`/public-surveys?surveyId=${surveyId}&stationId=${stationId}${vQuery}${preview}`}
      replace
    />
  );
}
